import { render, staticRenderFns } from "./SkuTable.vue?vue&type=template&id=7094f969&scoped=true"
import script from "./SkuTable.vue?vue&type=script&lang=js"
export * from "./SkuTable.vue?vue&type=script&lang=js"
import style0 from "./SkuTable.vue?vue&type=style&index=0&id=7094f969&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7094f969",
  null
  
)

export default component.exports